import { getStyleProps, passProps } from "modules/themes/styleUtils";

import MuiAutocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";

import { styled } from "@mui/material/styles";
import React from "react";
import { PrimaryInput } from "components/input";

const StyledMuiAutocomplete = styled(MuiAutocomplete)(({ theme }) => ({
  "& .Mui-focused": {
    fieldset: {
      borderColor: `${theme.palette.borders.highlight}!important`,
    },
  },
}));

export const Autocomplete = (props: AutocompleteProps) => {
  return (
    <StyledMuiAutocomplete {...passProps(props)} {...getStyleProps(props)} />
  );
};

export const StyledAutocomplete = (
  props: AutocompleteProps & { disableClearButton?: boolean }
) => {
  const { disableClearButton, ...rest } = props;
  return (
    <StyledMuiAutocomplete
      freeSolo
      size="small"
      disableClearable
      renderInput={(params) => (
        <PrimaryInput
          {...params}
          InputProps={{
            ...params.InputProps,
            placeholder: rest.placeholder || "",
            sx: {
              borderRadius: "10px",
              fontSize: "14px",
              ...(disableClearButton
                ? {
                    "[type='search']::-webkit-search-cancel-button": {
                      appearance: "none",
                    },
                  }
                : {}),
              ...(params.InputProps?.sx || {}),
            },
            type: "search",
          }}
        />
      )}
      {...rest}
      {...getStyleProps(rest)}
    />
  );
};
